import { AUTH } from '@/api'
import { uiHelper, i18nHelper } from '@/utils'
import { SET_WISHLIST } from './wishlist.module'

/* Define Module Name */
const MODULE_NAME = 'auth/'

/* Define Action Name */
const A_LOGIN = 'login'
const A_LOAD_PROFILE = 'loadProfile'
const A_REGISTER = 'register'
const A_GET_PROFILE = 'getProfile'
const A_LOGOUT = 'logout'
const A_EDIT_PROFILE = 'editProfile'
const A_CHECK_CURRENT_PASSWORD = 'checkCurrentPassword'
const A_CHANGE_PASSWORD = 'changePassword'
const A_GET_ADDRESS = 'getAddress'
const A_GET_ADDRESS_DETAIL = 'getAddressDetail'
const A_ADD_ADDRESS = 'addAddress'
const A_EDIT_ADDRESS = 'editAddress'
const A_EDIT_ADDRESS_COUNTRY = 'editAddressCountry'
const A_DELETE_ADDRESS = 'deleteAddress'
const A_ENABLE_PUSH_NOTIFICATION = 'enablePushNotification'
const A_REGISTER_REFERRAL = 'registerReferral'
const A_GET_POINT_TRANSFER_MEMBER_LIST = 'getPointTransferMemberList'
const A_TRANSFER_POINT = 'transferPoint'
const A_GET_SHARE_AND_REWARDS_CONTENT = 'getShareAndRewardsContent'

/* Define Getter Name */
const G_USER_FROM_SG = 'isSGUser'

/* Define Mutation Name */
const M_LOGIN = 'login'
const M_STORE_PASSWORD = 'storePasswordForm'
const M_STORE_REFERRAL = 'storeReferralForm'
const M_SET_CURRENT_USER = 'setCurrentUser'
const M_UNSET_CURRENT_USER = 'unsetCurrentUser'
const M_LOAD_USER_PENDING = 'loadUserPending'
const M_LOAD_USER_COMPLETE = 'loadUserComplete'
const M_SET_USER_ADDRESS = 'setUserAddress'
const M_SET_CURRENT_DELIVERY_ADDRESS = 'setCurrentDeliveryAddress'
const M_SET_CURRENT_BILLING_ADDRESS = 'setCurrentBillingAddress'
const M_SET_USER_LANGUAGE = 'setUserLanguage'
const M_SET_POINT_TRANSFER_INFO = 'setPointTransferInfo'

/* Define Export Name */
export const AUTH_LOAD_PROFILE = MODULE_NAME + A_GET_PROFILE

const state = {
  currentUser: null,
  userIsLoading: false,
  passwordForm: {},
  referralForm: {},
  addressList: [],
  currentDeliveryAddress: { receiver_name: '', address: '', contact_no: '' },
  currentBillingAddress: { receiver_name: '', address: '', contact_no: '' },
  language: 'en',
  momentLocale: 'en',
  pointTransferInfo: null
}

//Getters
const getters = {
  [G_USER_FROM_SG]: (state, getters, rootState, rootGetters) => {
    let id = rootGetters['common/SGCountryId']
    return state.currentUser ? state.currentUser.country_id === id : true
  }
}

// Actions
const actions = {
  async [A_LOGIN]({ commit, dispatch }, data) {
    console.log('LOGIN')
    await AUTH.login(data)
      .then((response) => {
        let result = response
        console.log('SUCCESS', result)
        commit(M_LOGIN, result)
        dispatch('page/getLandingPageData', null, { root: true })
        dispatch(A_GET_PROFILE)
      })
      .catch((error) => {
        let result = error
        throw result.error_message
      })
  },

  [A_LOAD_PROFILE]({ dispatch }) {
    if (uiHelper.getLocalStorage('token')) dispatch(A_GET_PROFILE)
    if (uiHelper.getLocalStorage('language')) i18nHelper.setActiveLanguage(uiHelper.getLocalStorage('language'))
  },

  async [A_REGISTER]({ state, rootState, commit, dispatch }, form) {
    const payload = {
      ...rootState.common.savedForm,
      ...state.passwordForm,
      ...state.referralForm,
      ...form
    }
    await AUTH.register(payload).then((result) => {
      commit(M_LOGIN, result)
      dispatch(A_GET_PROFILE)
    })
  },

  async [A_GET_PROFILE]({ dispatch, commit, getters, rootGetters }) {
    commit(M_LOAD_USER_PENDING)
    await AUTH.getProfile()
      .then(({ profile, wish }) => {
        let languageList = rootGetters['common/languageList']

        commit(M_SET_CURRENT_USER, profile)
        dispatch('page/getLandingPageData', null, { root: true })
        commit(M_SET_USER_LANGUAGE, languageList.find((language) => language.id === profile.language_id).code)
        commit(SET_WISHLIST, wish, { root: true })
        if (profile.roles.toLowerCase() === 'member') dispatch('agent/getAgentApplicationStatus', null, { root: true })
        if (profile.roles.toLowerCase() === 'agent') dispatch('agent/getAgentStatus', null, { root: true })
      })
      .finally(() => {
        commit(M_LOAD_USER_COMPLETE)
      })
  },

  async [A_LOGOUT]({ commit, dispatch }) {
    await AUTH.logout()
      .then(() => {
        // commit(M_UNSET_CURRENT_USER)
        // uiHelper.removeLocalStorage('token')
        // dispatch('page/getLandingPageData', null, { root: true })
        // TODO: unset wishlist and cart also
      })
      .catch((error) => {
        let result = error
        throw result.error_message
      })
      .finally(() => {
        commit(M_UNSET_CURRENT_USER)
        uiHelper.removeLocalStorage('token')
        dispatch('page/getLandingPageData', null, { root: true })
      })
  },

  async [A_EDIT_PROFILE]({ commit, dispatch }, data) {
    await AUTH.editProfile(data)
      .then(() => {
        dispatch(A_GET_PROFILE)
      })
      .catch((error) => {
        let result = error
        throw result.error_message
      })
  },

  async [A_CHECK_CURRENT_PASSWORD]({ commit, dispatch }, data) {
    await AUTH.checkCurrentPassword(data)
      .then(() => {
        // dispatch(A_GET_PROFILE)
      })
      .catch((error) => {
        let result = error
        throw result.error_message
      })
  },

  async [A_CHANGE_PASSWORD]({ commit, dispatch }, data) {
    await AUTH.changePassword(data)
      .then(() => {
        // dispatch(A_GET_PROFILE)
      })
      .catch((error) => {
        let result = error
        throw result.error_message
      })
  },

  async [A_GET_ADDRESS]({ commit }) {
    await AUTH.getAddress()
      .then(({ address }) => {
        commit(M_SET_USER_ADDRESS, address)
        let defaultDeliveryAddress = address.filter((f) => f.default_delivery_address == true)
        let defaultBillingAddress = address.filter((f) => f.default_billing_address == true)
        if (!state.currentDeliveryAddress.id) commit(M_SET_CURRENT_DELIVERY_ADDRESS, defaultDeliveryAddress[0])
        if (!state.currentBillingAddress.id) commit(M_SET_CURRENT_BILLING_ADDRESS, defaultBillingAddress[0])
      })
      .catch((error) => {
        let result = error
        throw result.error_message
      })
  },

  async [A_REGISTER_REFERRAL]({ state, rootState, commit, dispatch }, form) {
    await AUTH.registerReferral({
      ...rootState.common.savedForm,
      ...state.passwordForm,
      ...form
    }).then((result) => {
      commit(M_LOGIN, result)
      dispatch(A_GET_PROFILE)
    })
  },

  async [A_GET_ADDRESS_DETAIL]({ commit }, data) {
    return await AUTH.getAddressDetail(data)
  },

  async [A_ADD_ADDRESS]({ commit }, form) {
    await AUTH.addAddress(form)
  },

  async [A_EDIT_ADDRESS]({ commit }, { id, form }) {
    return await AUTH.editAddress(id, form)
  },

  async [A_DELETE_ADDRESS]({ commit, dispatch }, data) {
    await AUTH.deleteAddress(data)
      .then(() => {
        dispatch(A_GET_ADDRESS)
      })
      .catch((error) => {
        let result = error
        throw result.error_message
      })
  },

  async [A_ENABLE_PUSH_NOTIFICATION]({ dispatch }, form) {
    await AUTH.enablePushNotification(form).then((result) => {
      dispatch(A_GET_PROFILE)
    })
  },

  async [A_EDIT_ADDRESS_COUNTRY]({ commit }, data) {
    return await AUTH.editAddress(state.currentDeliveryAddress.id, { ...state.currentDeliveryAddress, country_id: data }).then((res) => {
      commit(M_SET_CURRENT_DELIVERY_ADDRESS, res.address)
    })
  },

  async [A_GET_POINT_TRANSFER_MEMBER_LIST]({ _ }, data) {
    return await AUTH.getPointTransferMemberList(data)
  },
  async [A_TRANSFER_POINT]({ commit, dispatch }, data) {
    return await AUTH.transferPoint(data)
      .then((res) => {
        dispatch(A_GET_PROFILE)
        commit(M_SET_POINT_TRANSFER_INFO, res)
      })
      .catch((error) => {
        let result = error
        throw result.error_message
      })
  },
  async [A_GET_SHARE_AND_REWARDS_CONTENT]() {
    return await AUTH.getShareAndRewards()
  }
}

// Mutations
const mutations = {
  [M_LOGIN](_, result) {
    uiHelper.setLocalStorage('token', result.token)
  },
  [M_STORE_PASSWORD](state, data) {
    state.passwordForm = data
  },
  [M_STORE_REFERRAL](state, data) {
    state.referralForm = data
  },
  [M_SET_CURRENT_USER](state, user) {
    state.currentUser = user
    console.log('CURRENT USER', state.currentUser)
  },
  [M_UNSET_CURRENT_USER](state) {
    state.currentUser = null
  },
  [M_LOAD_USER_PENDING](state) {
    state.userIsLoading = true
  },
  [M_LOAD_USER_COMPLETE](state) {
    state.userIsLoading = false
  },
  [M_SET_USER_ADDRESS](state, list) {
    state.addressList = list
  },
  [M_SET_CURRENT_DELIVERY_ADDRESS](state, address) {
    if (address === undefined) {
      state.currentDeliveryAddress = {
        receiver_name: '',
        address: '',
        contact_no: ''
      }
    } else {
      state.currentDeliveryAddress = address
    }
  },
  [M_SET_CURRENT_BILLING_ADDRESS](state, address) {
    if (address === undefined) {
      state.currentBillingAddress = {
        receiver_name: '',
        address: '',
        contact_no: ''
      }
    } else {
      state.currentBillingAddress = address
    }
  },
  [M_SET_USER_LANGUAGE](state, language) {
    let lang = language === 'cn' ? 'zh' : language
    i18nHelper.setActiveLanguage(lang)
    state.language = lang
    state.momentLocale = lang === 'zh' ? 'zh-cn' : lang
  },
  [M_SET_POINT_TRANSFER_INFO](state, info) {
    state.pointTransferInfo = info
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
